module.exports = __webpack_public_path__ + "media/images/kvimg_3pc-06e77ae89674a4fa38a51844980f2db9.jpg";